(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    const slotTrigger = document.querySelector('[data-naxarly-slot-trigger]');
    const slotLabel = slotTrigger?.querySelector('[data-naxarly-slot-label]');

    if (!slotTrigger || !slotLabel) return;

    const updateSlotLabel = () => {
      const availability = window.Naxarly?.Event?.getAvailability?.();
      const location = availability?.city || availability?.location;

      if (availability?.date && availability?.time && location) {
        slotTrigger.classList.add('has-slot');
        const date = new Date(`${availability.date}T00:00:00`);
        const [hours, minutes] = availability.time.split(':').map(Number);
        const period = hours >= 12 ? 'PM' : 'AM';
        const displayHour = hours % 12 || 12;
        const displayDate = Number.isNaN(date.getTime())
          ? availability.date
          : date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
        const displayTime = `${displayHour}:${String(minutes || 0).padStart(2, '0')} ${period}`;
        slotLabel.textContent = `${displayDate} • ${displayTime} • ${location}`;
        slotTrigger.setAttribute('aria-label', `Event slot: ${slotLabel.textContent}`);
      } else {
        slotTrigger.classList.remove('has-slot');
        slotLabel.textContent = 'Select Event Slot';
        slotTrigger.setAttribute('aria-label', 'Select event slot');
      }
    };

    slotTrigger.addEventListener('click', () => {
      window.Naxarly?.SlotSelector?.open();
    });

    window.Naxarly?.SlotSelector?.subscribe(updateSlotLabel);
    updateSlotLabel();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naxarly-package-decision-v4"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-nps]').forEach(function(r){
    if(r.dataset.v4Ready)return;
    r.dataset.v4Ready='true';
    var tabs=[...r.querySelectorAll('[role=tab][data-category]')],rail=r.querySelector('[data-package-rail]'),slot=r.querySelector('[data-open-slot]'),cards=[];
    var params=new URLSearchParams(window.location.search),requestedPackage=params.get('package');
    if(!tabs.length||!rail)return;
    function read(c){try{return JSON.parse(c.querySelector('[data-package-data]').textContent)}catch(e){return{title:'Package'}}}
    function itemId(d){return'service-'+d.key}
    function hasSlot(){var s=window.Naxarly?.Event?.getAvailability?.()||{};return Boolean(s.date&&s.time&&s.city)}
    function drawSlot(){
      if(!slot)return;
      var availability=window.Naxarly?.Event?.getAvailability?.()||{},summary=slot.querySelector('[data-slot-summary]'),action=slot.querySelector('i');
      slot.hidden=false;
      if(availability.date&&availability.time&&availability.city){
        var dateParts=availability.date.split('-').map(Number),timeParts=availability.time.split(':').map(Number);
        var dateLabel=dateParts.length===3?new Intl.DateTimeFormat('en-IN',{day:'numeric',month:'short',year:'numeric'}).format(new Date(dateParts[0],dateParts[1]-1,dateParts[2])):availability.date;
        var timeLabel=new Intl.DateTimeFormat('en-IN',{hour:'numeric',minute:'2-digit',hour12:true}).format(new Date(2000,0,1,timeParts[0]||0,timeParts[1]||0));
        if(summary)summary.textContent=dateLabel+' · '+timeLabel+' · '+availability.city;
        if(action)action.textContent='Change details →';
      }else{
        if(summary)summary.textContent=slot.dataset.emptyText;
        if(action)action.textContent=slot.dataset.actionText+' →';
      }
    }
    function updateWhatsApp(c,d){
      var whatsapp=c?.querySelector('[data-package-whatsapp]');
      if(!whatsapp)return;
      try{
        var url=new URL(whatsapp.dataset.baseHref,window.location.origin);
        var availability=window.Naxarly?.Event?.getAvailability?.()||{},lines=['Hello, I need help with a Naxarly package.','Service: '+r.dataset.serviceTitle,'Package: '+d.title];
        if(availability.date&&availability.time&&availability.city)lines.push('Event: '+availability.date+', '+availability.time+', '+availability.city);
        url.searchParams.set('text',lines.join('\n'));
        whatsapp.href=url.toString();
      }catch(error){whatsapp.href=whatsapp.dataset.baseHref}
    }
    function select(c){
      if(!c)return;
      cards.forEach(function(x){var on=x===c;x.classList.toggle('is-selected',on);x.querySelector('[data-package-select]')?.setAttribute('aria-pressed',String(on))});
      var data=read(c);
      window.Naxarly?.ServicePage?.select(data);
      updateWhatsApp(c,data);
    }
    function viewGallery(c){
      select(c);
      var d=read(c);
      window.dispatchEvent(new CustomEvent('naxarly:view-gallery',{detail:{packageKey:d.key,preferredTab:r.dataset.galleryDefault||'photos'}}));
    }
    function drawCard(c,announce){
      var d=read(c),added=window.Naxarly?.Event?.hasService?.(itemId(d))||false,button=c.querySelector('[data-package-cart]'),label=c.querySelector('[data-cart-label]'),icon=c.querySelector('[data-cart-icon]'),status=c.querySelector('[data-package-status]');
      c.classList.toggle('is-in-cart',added);
      if(label)label.textContent=added?'Remove':'Add to Cart';
      if(icon)icon.textContent=added?'−':'+';
      button?.setAttribute('aria-pressed',String(added));
      if(status&&!announce)status.textContent='';
    }
    function addOrRemove(c){
      select(c);
      var d=read(c),id=itemId(d),added=window.Naxarly?.Event?.hasService?.(id),status=c.querySelector('[data-package-status]'),label=c.querySelector('[data-cart-label]');
      if(added){
        window.Naxarly.Event.getState().items.filter(function(item){return item.parentPackageStableKey===d.stableKey}).forEach(function(item){window.Naxarly.Event.removeService(item.id)});
        window.Naxarly.Event.removeService(id);
        window.dispatchEvent(new CustomEvent('naxarly:event:change',{detail:window.Naxarly.Event.getState()}));
        if(status)status.textContent='Removed from Cart';
        drawCard(c,true);
        setTimeout(function(){if(status)status.textContent=''},1300);
        return;
      }
      var s=window.Naxarly?.Event?.getAvailability?.()||{};
      if(!s.date||!s.time||!s.city){window.Naxarly?.SlotSelector?.open();return}
      window.Naxarly?.Event?.addService?.({id:id,type:'service',service:d.categoryTitle,package:d.title,packageKey:d.key,stableKey:d.stableKey,image:d.image,duration:d.duration,allowance:d.allowance,variantId:d.variantId,fullPrice:d.totalPrice,advancePrice:d.advancePrice,resourceKey:d.resourceKey,resourceRequirements:d.resourceRequirements});
      c.classList.remove('is-just-added');void c.offsetWidth;c.classList.add('is-just-added');
      if(label)label.textContent='Added';
      if(status)status.textContent=d.title+' added to Cart';
      setTimeout(function(){c.classList.remove('is-just-added');drawCard(c,true)},900);
      setTimeout(function(){if(status)status.textContent=''},2200);
    }
    function details(c){
      select(c);
      var d=read(c),reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      requestAnimationFrame(function(){
        var packageContent=document.querySelector('[data-nsc-modular][data-package-key="'+CSS.escape(d.key)+'"]'),
            target=packageContent?.querySelector('[data-package-details-target]'),
            heading=target?.querySelector('h3');
        target?.scrollIntoView({behavior:reduced?'auto':'smooth',block:'start'});
        heading?.focus({preventScroll:true});
      });
    }
    function bind(){
      cards=[...rail.querySelectorAll('[data-package]')];
      cards.forEach(function(c){
        c.querySelector('[data-package-gallery]')?.addEventListener('click',function(){viewGallery(c)});
        c.querySelector('[data-package-select]')?.addEventListener('click',function(){select(c)});
        c.querySelector('[data-package-cart]')?.addEventListener('click',function(){addOrRemove(c)});
        c.querySelector('[data-package-details]')?.addEventListener('click',function(){details(c)});
        c.querySelectorAll('[data-customize]').forEach(function(b){b.addEventListener('click',function(){select(c);window.dispatchEvent(new CustomEvent('naxarly:customize',{detail:{packageKey:read(c).key,action:b.dataset.action,target:b.dataset.target}}))})});
        updateWhatsApp(c,read(c));
        drawCard(c,false);
      });
      select(cards.find(function(c){return requestedPackage&&c.dataset.packageKey===requestedPackage})||cards.find(function(c){return c.dataset.default==='true'})||cards[0]);
    }
    function category(key,replace){
      tabs.forEach(function(t){var on=t.dataset.category===key;t.classList.toggle('is-active',on);t.setAttribute('aria-selected',on?'true':'false');t.tabIndex=on?0:-1});
      if(replace){var tpl=r.querySelector('template[data-package-template="'+CSS.escape(key)+'"]');rail.replaceChildren(tpl?tpl.content.cloneNode(true):document.createDocumentFragment())}
      bind();
    }
    tabs.forEach(function(t){t.addEventListener('click',function(){category(t.dataset.category,true)})});
    slot?.addEventListener('click',function(){window.Naxarly?.SlotSelector?.open()});
    window.addEventListener('naxarly:event:change',function(){cards.forEach(function(c){drawCard(c,false);updateWhatsApp(c,read(c))});drawSlot()});
    window.addEventListener('pageshow',function(){cards.forEach(function(c){drawCard(c,false)});drawSlot()});
    var requested=params.get('category'),requestedTab=requested&&tabs.find(function(t){return t.dataset.categoryKey===requested});
    category(requestedTab?requestedTab.dataset.category:r.dataset.initialCategory,Boolean(requestedTab));
    drawSlot();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naxarly-package-selector-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('[data-nps]').forEach(function(r){if(r.dataset.ready)return;r.dataset.ready='true';var tabs=[...r.querySelectorAll('[role=tab][data-category]')],rail=r.querySelector('[data-package-rail]'),add=r.querySelector('[data-add-package]');if(!tabs.length||!rail||!add)return;var cards=[];function read(c){try{return JSON.parse(c.querySelector('[data-package-data]').textContent)}catch(e){return{title:'Package',categoryTitle:''}}}function label(d){var full=(d.categoryTitle?d.categoryTitle+' – ':'')+d.title;add.textContent=window.innerWidth<480?'Add '+d.title+' to Event':'Add '+full+' to Event';add.setAttribute('aria-label','Add '+full+' to Event')}function choose(c){if(!c){add.textContent='No packages available';add.disabled=true;return}cards.forEach(function(x){var selected=x===c;x.classList.toggle('is-selected',selected);x.setAttribute('aria-selected',String(selected))});var d=read(c);add.dataset.value=JSON.stringify(d);if(!d.variantId){add.disabled=true;add.textContent='Booking advance unavailable';add.setAttribute('aria-label','Booking advance product is not configured for '+d.title)}else{add.disabled=false;label(d)}window.Naxarly.ServicePage.select(d)}function bindCards(){cards=[...rail.querySelectorAll('[data-package]')];cards.forEach(function(c){c.querySelector('[data-package-select]').addEventListener('click',function(){choose(c)});c.querySelectorAll('[data-customize]').forEach(function(link){link.addEventListener('click',function(){choose(c);window.dispatchEvent(new CustomEvent('naxarly:customize',{detail:{packageKey:read(c).key,action:link.dataset.action,target:link.dataset.target}}))})})});rail.scrollTo({left:0,behavior:'auto'});choose(cards.find(function(c){return c.dataset.default==='true'})||cards[0])}function category(k,replace){tabs.forEach(function(x){var selected=x.dataset.category===k;x.classList.toggle('is-active',selected);x.setAttribute('aria-selected',String(selected))});if(replace){var template=r.querySelector('template[data-package-template="'+CSS.escape(k)+'"]');rail.replaceChildren(template?template.content.cloneNode(true):document.createDocumentFragment())}bindCards()}tabs.forEach(function(t){t.addEventListener('click',function(){category(t.dataset.category,true)})});r.querySelectorAll('[data-open-slot]').forEach(function(b){b.addEventListener('click',function(){window.Naxarly?.SlotSelector?.open()})});add.addEventListener('click',function(){var d=JSON.parse(add.dataset.value||'{}'),s=window.Naxarly?.Event?.getAvailability?.()||{};if(!d.variantId)return;if(!s.date||!s.time||!s.city){window.Naxarly?.SlotSelector?.open();return}window.Naxarly?.Event?.addService?.({id:'service-'+d.key,type:'service',service:d.categoryTitle,package:d.title,packageKey:d.key,stableKey:d.stableKey,variantId:d.variantId,fullPrice:d.totalPrice,advancePrice:d.advancePrice,resourceKey:d.resourceKey,resourceRequirements:d.resourceRequirements})});window.addEventListener('resize',function(){var c=rail.querySelector('.nps__card.is-selected');if(c){var d=read(c);if(d.variantId)label(d)}});category(r.dataset.initialCategory,false)})});

  } catch(e) { console.error(e); }
})();
})();
